module.exports = __webpack_public_path__ + "static/media/5-a.0734820c.jpg";